export default "__VITE_ASSET__B4e1hGOK__"